export default function getLoadingFromState(
  slice: any,
  metaId?: any,
  initValue = true
) {
  const key = metaId ? `${metaId}-loading` : 'loading';

  return (state: any) => Boolean(state.getIn([slice, 'meta', key], initValue));
}
